import { AnyAction, Reducer } from "redux";
import produce from "immer";

import { createInstanceMapReducer, EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IClearAction, IReportingScalarState, IResultAction, ReportingScalar } from "./types";

export const reportingScalar: Reducer<ReportingScalar> = (state = { value: "" }, action) => {
    if (action instanceof IResultAction)
        return { value: action.payload.result };

    return state;
};

const instanceKeyResolver = (action: AnyAction) => {
    if (action instanceof IResultAction)
        return action.meta.dataKey;

    return undefined;
};

const instanceMapReducer = createInstanceMapReducer(reportingScalar, instanceKeyResolver);

export const reducer: Reducer<IReportingScalarState> = (state = EMPTY_OBJECT, action) => {
    if (action instanceof IClearAction)
        return produce(state, (draft) => {
            delete draft[action.meta.dataKey];
        });
    if (action instanceof IResultAction)
        return instanceMapReducer(state, action);

    return state;
};
